import { flagFactory } from '../icon';
import Svg from './lt.svg';

export default flagFactory(Svg);
